export default "__VITE_ASSET__DVQLzbzJ__"